import { brands } from "brands";
import React from "react";
import { Link } from "react-router-dom";

export const Home = () => (
  <main className="mx-auto flex min-h-screen max-w-7xl flex-col items-center justify-center px-4 text-center sm:px-6 lg:px-8">
    <div className="flex flex-wrap items-center justify-center gap-6">
      {brands.map((brand, i) => (
        <React.Fragment key={brand.id}>
          {i > 0 && (
            <span aria-hidden="true" className="text-4xl font-light text-gray-400">
              /
            </span>
          )}
          <img src={brand.logoSrc} alt={brand.logoAlt} className="h-16 w-auto" />
        </React.Fragment>
      ))}
    </div>
    <h1 className="mt-8 text-3xl font-semibold tracking-tight text-gray-900 sm:text-4xl">Account Management</h1>
    <Link
      to="/delete-account"
      className="mt-12 inline-flex items-center justify-center rounded-full bg-red-500 px-8 py-3 font-medium text-white transition-all hover:brightness-110 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2"
    >
      Delete Account
    </Link>
  </main>
);
